module.exports = __webpack_public_path__ + "4c6a0c5c599c80d08a25f2f6fb23cad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image5.png
// module id = uyHh
// module chunks = 0